import { useEffect, useState } from 'react';
import { db } from '../../../../../../../../firebase';
import { Button, Card, CardActions, CardMedia, Grid, IconButton, makeStyles } from '@material-ui/core';
import { Add, Delete, Star } from '@material-ui/icons';
import StarIcon from '@material-ui/icons/Star';
import { useDispatch, useSelector } from 'react-redux';
import { showAddItemPhotosDialog } from '../item-photos-add/item-photos-add-slice';
import { getItemPhotosService, setItemThumbnail } from './item-photos-list-service';
import ItemPhotosListEmpty from './item-photos-list-empty';
import ItemPhotosListLoading from './item-photos-list-loading';
import { showDeleteItemPhotosDialog } from '../item-photos-delete/item-photos-delete-slice';
import { showErrorSnackbar } from '../../../../../../../shared/snackbar/snackbar-slice';

const useStyles = makeStyles((theme) => ({
  button: {
      background: "#111111",
      color: "#fbbbd3",
      '&:hover': {
          backgroundColor: '#fbbbd3',
          color: '#111111',
      },
  },
  buttonText: {
      color: "#111111",
      '&:hover': {
          backgroundColor: '#fbbbd3',
          color: '#111111',
      },
  },
  text: {
      color: "#111111",
  },
  title: {
      background:"#111111",
  },
  starIcon: {
    marginRight: theme.spacing(1),
    color: 'gold',
  },
}));

const ItemPhotosList = (props) => {
  const classes = useStyles();
  const formData = props.formData;
  const itemPhotosCollection = useSelector((state) => state.itemPhotosListSlice.rows);
  const isLoading = useSelector((state) => state.itemPhotosListSlice.isLoading);
  const [thumbnailPhotoUrl, setThumbnailPhotoUrl] = useState(null);
  const dispatch = useDispatch();

  const item_id = props.item_id;

  // get data
//   useEffect(() => {
//     const fetchData = async () => {
//         try {
//           await getItemPhotosService(dispatch, db, "items", item_id);
//         } catch(e) {
//           dispatch(showErrorSnackbar('Something went wrong when fetching.'));
//           console.error("ItemPhotosList error: ", e);
//         }
//     };
//     fetchData();
// }, [dispatch, item_id]);

// set thumbnail
  useEffect(() => {
    if (formData.item_thumbnail?.length) {
      setThumbnailPhotoUrl(formData.item_thumbnail);
    }
  }, [formData.item_thumbnail]);

  const handleAddOpen = () => {
    dispatch(showAddItemPhotosDialog());
  };

  // open delete dialog
  const handleDeleteOpen = (photoUrl) => {
    dispatch(showDeleteItemPhotosDialog(photoUrl));
  };

  const handleSetThumbnail = (photoUrl) => {
    setThumbnailPhotoUrl(photoUrl);
    const new_formData = {
      ...formData,
      item_thumbnail: photoUrl,
    }
    setItemThumbnail(dispatch, db, 'items', item_id, new_formData);
  };

  // return loading state if isLoading is true
  // if (isLoading) {
  //   return <ItemPhotosListLoading/>
  // }

  // // return empty state if isLoading is false and itemPhotosCollection has no collection
  // if (!isLoading && itemPhotosCollection.length === 0) {
  //   return <ItemPhotosListEmpty/>
  // }

  return (
    <>
    <div style={{ display: "flex", alignItems: "center", marginBottom: 10}}>
        <Button
            variant="contained"
            className={classes.button}
            startIcon={<Add/>}
            onClick={handleAddOpen}
        >
            Add
        </Button>
      </div>
      <div align="left">
        <Grid container spacing={2}>
          {itemPhotosCollection.map((photoUrl, index) => (
            <Grid item key={index}>
              <Card>
                {/* {thumbnailPhotoUrl === photoUrl && (
                  <StarIcon className={classes.starIcon} />
                )} */}
                <IconButton
                  className={thumbnailPhotoUrl === photoUrl ? classes.starIcon : classes.starIconActive}
                  onClick={() => handleSetThumbnail(photoUrl)}
                  size="small"
                >
                  <Star />
                </IconButton>
                <CardMedia component="img" image={photoUrl} alt="Photo" style={{ width: 150, height: 150 }} />
                <CardActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <IconButton
                    className={classes.buttonText}
                    onClick={() => handleDeleteOpen(photoUrl)}
                    size="small"
                  >
                      <Delete/>
                  </IconButton>
                  {/* <IconButton
                    className={classes.buttonText}
                    onClick={() => handleSetThumbnail(photoUrl)}
                    size="small"
                  >
                    Set as Thumbnail
                  </IconButton> */}
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>

    </>
  );
};

export default ItemPhotosList;
